<template lang="pug">
div
  .text-body-1.font-weight-bold {{ title }}
  v-divider.mb-3
  v-card.d-flex.mb-3(
    outlined,
    v-for="({ title, path }, i) in items",
    :key="i",
    :href="files + path",
    :download="title",
    target="_blank"
  )
    v-icon.ml-4 fas fa-file
    v-card-text.black--text {{ title }}
</template>

<script>
const _config = {
  title: "Anexos",
};

export default {
  data: () => ({ ..._config }),
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
</style>
